module.exports = __webpack_public_path__ + "img/SES_192332550.42326659.jpg";